import { render, staticRenderFns } from "./InspectionDetails.vue?vue&type=template&id=8adbaa60&scoped=true"
import script from "./InspectionDetails.vue?vue&type=script&lang=js"
export * from "./InspectionDetails.vue?vue&type=script&lang=js"
import style0 from "./InspectionDetails.vue?vue&type=style&index=0&id=8adbaa60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adbaa60",
  null
  
)

export default component.exports